import { Provider } from 'react-redux';
import type { ReactNode } from 'react';
import { store } from '@/app/store';

export function ReduxProvider({ children }: { children: ReactNode }) {
  return <Provider store={store}>{children}</Provider>;
}
